export const getCroppedImg = (
	imageSrc,
	croppedAreaPixels,
	fileName = "cropped.jpg"
) => {
	return new Promise((resolve, reject) => {
		const image = new Image();
		image.crossOrigin = "anonymous";
		image.src = imageSrc;

		image.onload = () => {
			const canvas = document.createElement("canvas");
			canvas.width = croppedAreaPixels.width;
			canvas.height = croppedAreaPixels.height;

			const ctx = canvas.getContext("2d");
			ctx.drawImage(
				image,
				croppedAreaPixels.x,
				croppedAreaPixels.y,
				croppedAreaPixels.width,
				croppedAreaPixels.height,
				0,
				0,
				croppedAreaPixels.width,
				croppedAreaPixels.height
			);

			canvas.toBlob((blob) => {
				if (!blob) {return reject(new Error("Canvas is empty"));}
				const file = new File([blob], fileName, { type: "image/jpeg" });
				resolve(file);
			}, "image/jpeg");
		};

		image.onerror = () => reject(new Error("Image load error"));
	});
};
